export const auctionTableStyle = {
  wrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },

  content: {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: '8px',
    background: 'var(--default-white)',
    boxShadow: 'var(--box-shadow--1)',
    padding: '12px 0',
  },

  searchButton: {
    textTransform: 'capitalize',
    width: '200px',

    '& svg': {
      width: '24px',
      height: '24px',

      '& path': {
        fill: 'var(--default-white)',
      },
    },
  },

  tableContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 'calc(100% - 138px)',
    boxShadow: 'var(--box-shadow--1)',
  },

  container: {
    padding: '0 16px',
  },

  table: {
    maxWidth: '846px',
    tableLayout: 'fixed',
  },

  tableHeader: {
    '& > :nth-of-type(1)': {
      width: '7%',
      textTransform: 'uppercase',
    },
    '& > :nth-of-type(2)': {
      paddingLeft: '60px !important',
      width: '28%',
    },
    '& > :nth-of-type(3)': {
      width: '7%',
    },
    '& > :nth-of-type(4)': {
      width: '11%',
    },
    '& > :nth-of-type(5)': {
      width: '11%',
    },
    '& > :nth-of-type(6)': {
      width: '11%',
    },
    '& > :nth-of-type(7)': {
      width: '11%',
    },
    '& > :nth-of-type(8)': {
      width: '8%',
    },
    '& > :nth-of-type(9)': {
      width: '6%',
    },
  },

  tableBody: {
    '& > :nth-of-type(1)': {
      fontSize: '12px',
    },
    '& > :nth-of-type(4)': {
      fontSize: '16px',
    },
    '& > :nth-of-type(4), > :nth-of-type(5), > :nth-of-type(6), > :nth-of-type(7)': {
      '& .MuiInputAdornment-root': {
        margin: 'unset',
        '& .MuiTypography-root.MuiTypography-body1': {
          fontSize: '16px',
        },
      },
      '& .MuiInputBase-input': {
        padding: '10px 12px 10px 2px',
      },
    },

    '& .MuiTableCell-root': {},
  },

  bodyCell: {
    display: 'flex',
    gap: '12px',
    padding: '8px 0',
  },

  bodyCellImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--neutral-100)',
    width: '48px',
    height: '48px',
    flexShrink: 0,
    borderRadius: '4px',

    svg: {
      height: '24px',
      width: '24px',

      path: {
        fill: 'var(--neutral-300)',
      },
    },

    marginLeft: '-8px',
    '& img': {
      width: '48px !important',
      height: '48px !important',
      borderRadius: '4px',
    },
  },

  bodyCellImageContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  bodyCellImageContentName: {
    fontWeight: '700 !important',
  },

  bodyCellImageContentCategory: {
    color: 'var(--neutral-300) !important',
  },

  menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  disabledMenuItem: {
    color: 'var(--neutral-300)',
    cursor: 'default',
  },

  auctionModal: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      padding: '48px 38px 0 48px',
      scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px 8px 0 0 ',
    },

    '&.MuiDialog-root': {
      height: 'calc(100% - 80px)',
    },

    '.MuiDialogContent-root': {
      alignItems: 'unset',
    },
  },

  detailsModal: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      padding: '48px 38px 0 48px',
      scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px',

      '& > .MuiBox-root': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
    },

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },

  profilePage: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      padding: '48px 38px 0 48px',
      scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px 8px 0 0',
    },

    '&.MuiDialog-root': {
      height: 'calc(100% - 80px)',
    },
  },

  deleteAuctionModal: {
    '.MuiPaper-root': {
      width: '100%',
      maxWidth: '770px',
      padding: '48px 200px',
    },
  },

  loader: {
    position: 'absolute',
    left: 'calc(50% - 25px)',
    top: '200px',
  },

  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '16px',
    marginBottom: '12px',
  },
};
